import { get } from './APIHelper';

/**
 * Fetch all props for a given sport — gated by props upgrade on the backend.
 * Returns an array of prop objects with player and line data.
 */
export const getProps = async sport => {
  return get(`proxy/api/v1/props?sport=${sport}`);
};
